import { getContentResource } from '~/core/ContentResource';

export default async ({ $axios, store, app }) => {
  const CONTENT_QUERY = {
    QoalaOnlineError: []
  };
  const locale = app.i18n.locales.find(locale => locale.code === app.i18n.locale).iso;
  const method = 'get';
  const type = 'generalError';
  const data = await getContentResource(CONTENT_QUERY, locale, method, type);
  let dataError = data ? data : [];

  const refresh = store.getters['user/getUserTokenRefresh'];
  const token = store.getters['user/getUserToken'];
  const allowedPath = path => {
    if (!path) return true;
    if (path.indexOf('/documents') >= 0) return false;
    // if (path.indexOf('/notifications/unread') >= 0) return false;
    if (path.indexOf('/banks') >= 0) return false;
    if (path.indexOf('/sessions') >= 0) return false;
    if (path.indexOf('/registrations') >= 0) return false;
    if (path.indexOf('/purchase') >= 0) return false;
    if (path.indexOf('/users/insurance') >= 0) return false;
    if (path.indexOf('/country-detect') >= 0) return false;
    if (path.indexOf('/policies/check') >= 0) return false;

    return true;
  };

  $axios.defaults.timeout = 1000 * 3600 * 48;

  if (token) {
    if (refresh) {
      store.dispatch('user/refreshToken', {
        credentials: {
          refresh
        },
        callback: () => {}
      });
    }
  }

  $axios.onRequest(async config => {
    const currentData = dataError[0];
    if (currentData && currentData.locale && app.i18n) {
      if (currentData.locale.indexOf(app.i18n.locale) < 0) {
        const currentLocale = app.i18n.locales.find(locale => locale.code === app.i18n.locale).iso;
        const currentData = await getContentResource(
          {
            QoalaOnlineError: []
          },
          currentLocale,
          'get',
          'generalError'
        );
        dataError = currentData ? currentData : [];
      }
    }
    const isLogin = store.getters['user/getUserToken'];
    const dataPayload = config.data || {};
    if (dataPayload.hideModalMessage) {
      config.data = dataPayload.data;
      config.hideModalMessage = dataPayload.hideModalMessage;
      return config;
    }
    if (!isLogin) {
      if (!allowedPath(config.url)) {
        // store.dispatch('general/setLoader', true);
        return config;
      }
      return Promise.reject();
    }
    if (
      dataPayload.hideLoading ||
      config.url.indexOf('/policies?sortDirection') >= 0 ||
      config.url.indexOf('/claims?orderBy') >= 0 ||
      config.url.indexOf('/contents/?source=qoalaapp') >= 0
    ) {
      config.data = dataPayload.data;
      return config;
    }
    if (config.method === 'post' || config.method === 'get' || config.method === 'put') {
      // store.dispatch('general/setLoader', true);
    }
    return config;
  });

  $axios.onResponse(() => {
    store.dispatch('general/setLoader', false);
  });

  $axios.onRequestError(async error => {
    const errorLogout = [
      'QUS-AUTH-008',
      'USER-SESSION-004',
      'USER-SESSION-003',
      'USER-SESSION-002',
      'USER-SESSION-001'
    ];
    const generalError = dataError.find(error => {
      return error.key === 'wentWrongLabel';
    });
    if (error.response) {
      const { errorCode, error_code } = error.response.data;
      if (error.response) {
        const { data, config } = error.response;
        const { hideModalMessage } = config;
        const errorTitle = dataError.find(mess => mess.key === 'sorryLabel');
        const message = {
          errorCode,
          title: errorTitle,
          message: data.message
        };
        const error_data_code = errorCode || error_code;
        try {
          const messageError = dataError.find(mess => mess.key === error_data_code);
          if (messageError) {
            message.message = messageError.value;
          } else {
            message.title = message.title + ' ' + error_data_code;
            message.message = generalError.value;
          }
          if (errorLogout.indexOf(error_data_code) >= 0) {
            await store.dispatch('user/logout');
          }
          store.dispatch('general/setLoader', false);
          store.dispatch('general/setModalMessage', !hideModalMessage);
          store.dispatch('general/setMessage', message);
          throw error;
        } catch (err) {
          return err;
        }
      }
    } else {
      return error;
    }
  });

  $axios.onResponseError(async error => {
    const errorLogout = [
      'QUS-AUTH-008',
      'USER-SESSION-004',
      'USER-SESSION-003',
      'USER-SESSION-002',
      'USER-SESSION-001'
    ];
    const generalError = dataError.find(error => {
      return error.key === 'wentWrongLabel';
    });
    if (error.response) {
      const { errorCode, error_code } = error.response.data;
      if (error.response) {
        const { data, config } = error.response;
        const { hideModalMessage } = config;
        const message = {
          errorCode,
          title: 'ERROR',
          message: data.message
        };
        const error_data_code = errorCode || error_code;
        try {
          const messageError = dataError.find(mess => mess.key === error_data_code);
          if (messageError) {
            message.message = messageError.value;
          } else {
            message.title = message.title + ' ' + error_data_code;
            message.message = generalError.value;
          }
          if (errorLogout.indexOf(error_data_code) >= 0) {
            await store.dispatch('user/logout');
          }
          store.dispatch('general/setLoader', false);
          store.dispatch('general/setModalMessage', !hideModalMessage);
          store.dispatch('general/setMessage', message);
          throw error;
        } catch (err) {
          console.log(err);
          return err;
        }
      } else {
        store.dispatch('general/setLoader', false);
        console.log('error', error);
      }
    } else {
      store.dispatch('general/setLoader', false);
      return error;
    }
  });

  $axios.onError(async error => {
    const errorLogout = [
      'QUS-AUTH-008',
      'USER-SESSION-004',
      'USER-SESSION-003',
      'USER-SESSION-002',
      'USER-SESSION-001'
    ];
    const generalError = dataError.find(error => {
      return error.key === 'wentWrongLabel';
    });
    if (error.response) {
      const { errorCode, error_code } = error.response.data;
      let apiPath = '';
      if (error.response) {
        const { data, config } = error.response;
        apiPath = config.url;
        const { hideModalMessage } = config;
        const message = {
          errorCode,
          title: 'ERROR',
          message: data.message
        };
        const error_data_code = errorCode || error_code;
        try {
          const messageError = dataError.find(mess => mess.key === error_data_code);
          if (messageError) {
            message.message = messageError.value;
          } else {
            message.title = message.title + ' ' + error_data_code;
            message.message = generalError.value;
          }
          if (errorLogout.indexOf(error_data_code) >= 0) {
            app.$gtm.pushEvent({ event: 'setUserId', userId: 'anonymous' });
            await store.dispatch('user/logout');
          }
          store.dispatch('general/setLoader', false);
          store.dispatch('general/setModalMessage', !hideModalMessage);
          store.dispatch('general/setMessage', message);
        } catch (err) {
          console.log(err);
          return err;
        }
      } else {
        apiPath = error.code;
        console.log('error', error);
      }

      if (allowedPath(apiPath)) {
        window.errorHandler.report(`${apiPath} -> ${JSON.stringify(error.response)}`);
      }
    } else {
      return error;
    }
  });
};
